import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IMarketingRequest } from '../../models/marketing-options.model';
import * as selector from '../../selectors';

@Component({
  selector: 'app-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.css']
})
export class MarketingComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  checked: boolean = true;
  allowAppNotifications: boolean;
  allowEmailNotifications: boolean;
  allowSMSNotifications: boolean;
  @Output() next = new EventEmitter<IMarketingRequest>();

  constructor(
    private router: Router,
    private store: Store
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(selector.getMarketing).subscribe(marketing => {
        this.allowAppNotifications = marketing.allowMarketingAppNotifications;
        this.allowEmailNotifications = marketing.allowMarketingEmailNotifications;
        this.allowSMSNotifications = marketing.allowMarketingSMSNotifications;
      })
    );
  }

  switchOptionsAppNotif() {
    this.allowAppNotifications = this.allowAppNotifications ? false : true;
  }
  switchOptionsEmailNotif() {
    this.allowEmailNotifications = this.allowEmailNotifications ? false : true;
  }
  switchOptionsSmsNotif() {
    this.allowSMSNotifications = this.allowSMSNotifications ? false : true;
  }

  accept() {
    const req: IMarketingRequest = {
      allowMarketingAppNotifications: this.allowAppNotifications,
      allowMarketingEmailNotifications: this.allowEmailNotifications,
      allowMarketingSMSNotifications: this.allowSMSNotifications
    };
    this.next.emit(req);
  }
}
